import PropTypes from "prop-types"
import { TableRow, TableCell } from "@mui/material"
import { percentageFormatter } from "helpers/formatters/numbers"

function DetailRow({ value }) {
  return <TableRow className="detail-row">
    <TableCell className="name" component="th" scope="row">
      <div className="factor-link-wrapper">
        <span>{value.label}{!!value.secondaryLabel && <span className="secondary">&nbsp;- {value.secondaryLabel}</span>}</span>
      </div>
    </TableCell>
    <TableCell align="right">
      {percentageFormatter(value.value)}
    </TableCell>
  </TableRow>
}

DetailRow.propTypes = {
  value: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
}

export default DetailRow
